<template>
    <div>
        <div class="label-input mb-2">
            {{ $t('dashboard.create.languageFilter.label') }}
        </div>

        <el-radio-group
            v-model="model"
        >
            <el-radio
                v-if="currentLanguage && currentLanguage.LanguageID"
                :label="currentLanguage.LanguageID"
            >
                {{ $t('dashboard.create.languageFilter.currentLanguage') }}
            </el-radio>
            <el-radio
                :label="layoutTemplatesAllLanguagesFilterValue"
            >
                {{ $t('dashboard.create.languageFilter.all') }}
            </el-radio>
        </el-radio-group>
    </div>
</template>

<script>
import { RadioGroup, Radio } from 'element-ui'
import { LAYOUT_TEMPLATES_ALL_LANGUAGES_FILTER_VALUE } from '@/enum/defaultDashboardSettings'
import { DEFAULT_LANGUAGE } from '@/enum/generic'

export default {
    components: {
        [RadioGroup.name]: RadioGroup,
        [Radio.name]: Radio
    },
    props: {
        value: {
            type: Number,
            required: true
        }
    },
    emits: [ 'input' ],
    data () {
        return {
            layoutTemplatesAllLanguagesFilterValue: LAYOUT_TEMPLATES_ALL_LANGUAGES_FILTER_VALUE
        }
    },
    computed: {
        currentLanguage () {
            return this.$store.getters['lang/getActiveLanguage'] || DEFAULT_LANGUAGE
        },
        model: {
            get () {
                return this.value
            },
            set (value) {
                console.log('Set?', value)
                this.$emit('input', value)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-radio-group {
    @apply flex;
}
</style>
